import React, { useEffect, useState } from "react"
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';



const Search = (props) => {

    const [searchText, setSearchText] = useState("")

    useEffect(()=>{
        setSearchText(props.searchText)
    },[props.searchText])

    const handleSearch = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setSearchText(e.target.value)
        props.handleSearch(e.target.value);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            props.handleSearch(e.target.value);
        }
    }

    return <div className="search-input">
        <FontAwesomeIcon icon={faSearch} className="icon-magnifier fa-solid" />
        <input
            type="text"
            name="input-search"
            className="form-control"
            onChange={handleSearch}
            onKeyDown={handleKeyPress}
            value={searchText}
            placeholder={props.placeholder}
        />
    </div>
}

export default Search;